import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import SvgRightArrowIcon from '../svg/RightArrowIcon';
import { viewDetailsText } from '../shared/SharedInternationalizations';

/**
 * Component to display a list item in the units column interface
 * @param {object} props - Props passed down from the parent component
 */
export const UnconnectedUnitsColumnListItem = (props) => {
  const { unit, unitArray, selectedUnit, unitId } = props;

  // The link text for the "view details" link. Set as a variable like this to be able to be passed into the button component

  /**
   * Function to calculate the number of child units for the unit to be displayed in the list item
   * @returns {number} - The total number of units that are children of the displayed unit
   * @description - Takes in the array of units from Redux then filters them down to find the number of items that have the parent unit id that matches the id of the currently displayed unit
   */
  const childUnits = () => {
    let children = [];
    let length = 0;
    children = unitArray.filter((u) => u.parent_unit === unit.id);
    if (children.length > 0) {
      length = children.length;
    }
    return (
      <span
        className={
          length === 0
            ? 'column-list-item__child-units column-list-item__child-units--none'
            : 'column-list-item__child-units '
        }
        data-test="units-column-list-item-child-units">
        {length}
      </span>
    );
  };

  const noName = (
    <FormattedMessage
      id="unitsColumnDisplay.unitNameListItemNoName"
      defaultMessage="(No Name)"
      description="No unit name was supplied"
    />
  );

  return (
    <div
      data-test={
        unit.is_active
          ? 'unit-column-list-item'
          : 'unit-column-list-item-archived'
      }
      className={
        selectedUnit === unitId
          ? 'units-column-view__column-list-item units-column-view__column-list-item--selected js-column-item js-column-item-selected'
          : 'units-column-view__column-list-item js-column-item'
      }>
      <div className="column-list-item__upper-container">
        <span
          className={
            unit.name
              ? !unit.is_active
                ? 'column-list-item__name text-large text-bold text-alert'
                : 'column-list-item__name text-large text-bold'
              : 'column-list-item__name text-large text-bold text-dimmed'
          }
          data-test="units-column-list-item-unit-name">
          {unit.name || noName}
        </span>

        {childUnits()}
      </div>
      <Link
        className="column-list-item__details-button"
        to={'/units/?path=' + unit.path}
        data-test="units-column-list-item-details-link">
        {viewDetailsText}
        <SvgRightArrowIcon
          className={
            unit.is_active
              ? 'text-success margin-left-10 text-large'
              : 'text-alert margin-left-10 text-large'
          }
        />
      </Link>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const unit = state.units.units[ownProps.unitId];
  const unitArray = Object.values(state.units.units);
  return {
    unitObj: state.units.units,
    unitArray: unitArray,
    unit,
  };
};
export default connect(mapStateToProps)(UnconnectedUnitsColumnListItem);
